// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PAiqwCuvxR1Iix {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.Mqz3gIKinnk2SJ {
  display: flex;
  justify-content: center;
}
.ErtIvTh0QAZQYm {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.LKn1VQhOuUwrfh {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.URPixNuOn9mz6f {
  font-style: italic;
}
.SpN4DoLX8D20FE {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.fL1mqeJ8FlthMG {
  display: flex;
  align-items: center;
  justify-content: center;
}
.z6O0rViLJjyXr6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.z6O0rViLJjyXr6 .GYlERJZfr4n_0B {
  margin: 12px 0 0;
}
.srs1LSDRCkCx_D {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.srs1LSDRCkCx_D button {
  margin-left: 8px;
}
.IAim_fU_i7ruAy {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .SpN4DoLX8D20FE {
    padding: 16px;
  }
}
.vzM3M0ytC_m2Ei {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.vzM3M0ytC_m2Ei label {
  font-weight: 700;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-top: 12px;
  margin-bottom: 4px;
}
.fmD323dbM7BU5n {
  display: block;
  min-width: 320px;
}
input.fmD323dbM7BU5n[type='text'],
textarea.fmD323dbM7BU5n {
  color: var(--ds-text, #172b4d);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  margin-top: 4px;
  margin-bottom: 12px;
}
input.fmD323dbM7BU5n[type='text']:hover,
textarea.fmD323dbM7BU5n:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
input.fmD323dbM7BU5n[type='text']:focus,
textarea.fmD323dbM7BU5n:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
input.fmD323dbM7BU5n[type='text']:disabled,
textarea.fmD323dbM7BU5n:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
input.fmD323dbM7BU5n[type='text'][readonly],
textarea.fmD323dbM7BU5n[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
input.fmD323dbM7BU5n[type='text'].hboHISr5j1lDpR,
textarea.fmD323dbM7BU5n.hboHISr5j1lDpR {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
input.fmD323dbM7BU5n[type='text'].hboHISr5j1lDpR:hover,
textarea.fmD323dbM7BU5n.hboHISr5j1lDpR:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
input.fmD323dbM7BU5n[type='text'].hboHISr5j1lDpR:focus,
textarea.fmD323dbM7BU5n.hboHISr5j1lDpR:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
input.fmD323dbM7BU5n[type='text'].judXa618OYFm2M,
textarea.fmD323dbM7BU5n.judXa618OYFm2M {
  width: 100%;
}
input.fmD323dbM7BU5n[type='text']::placeholder,
textarea.fmD323dbM7BU5n::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.k83HfNvrntUGNU {
  height: 200px;
}
.Q_ufZKEWNjPLm6 {
  flex-grow: 1;
  margin-left: 32px;
}
@media only screen and (max-width: 900px) {
  .vzM3M0ytC_m2Ei {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .Q_ufZKEWNjPLm6 {
    margin-left: 16px;
    color: var(--ds-text-subtle, #44546f);
  }
  .fmD323dbM7BU5n {
    margin-bottom: 16px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `PAiqwCuvxR1Iix`,
	"flexAndCenter": `Mqz3gIKinnk2SJ`,
	"body": `ErtIvTh0QAZQYm`,
	"navigationAndContent": `LKn1VQhOuUwrfh`,
	"learnMoreSubtle": `URPixNuOn9mz6f`,
	"content": `SpN4DoLX8D20FE`,
	"spinnerContainer": `fL1mqeJ8FlthMG`,
	"header": `z6O0rViLJjyXr6`,
	"title": `GYlERJZfr4n_0B`,
	"footer": `srs1LSDRCkCx_D`,
	"formFooter": `IAim_fU_i7ruAy`,
	"formSection": `vzM3M0ytC_m2Ei`,
	"pluginInput": `fmD323dbM7BU5n`,
	"input-error": `hboHISr5j1lDpR`,
	"full": `judXa618OYFm2M`,
	"descriptionInput": `k83HfNvrntUGNU`,
	"inputDescription": `Q_ufZKEWNjPLm6`
};
export default ___CSS_LOADER_EXPORT___;
